import React, { useRef } from 'react';
import ProTable from '@ant-design/pro-table';

import { contentPlayRecordPageList } from '@/services/userManager';
import { guuid } from '@/utils/utils';
import { history } from 'umi';
const OrderRecordView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId } = props;
  /// 订单记录
  const orderTableRef = useRef();

  const goRecord = (record) => {
    history.push(`/operating/order?orderNo=${record.orderNo}`);
  };

  const orderTableColumns = [
    {
      title: '点播内容标题',
      dataIndex: 'title',
      hideInSearch: true,
    },
    {
      title: '内容类型',
      dataIndex: 'contentTypeStr',
    },
    {
      title: '类型',
      dataIndex: 'playStatusStr',
    },
    {
      title: '时间',
      dataIndex: 'time',
    },
    {
      title: '播放来源',
      dataIndex: 'playSource',
      hideInSearch: true,
    },
  ];
  // const { formData, extraButton, onSearch, onReset, loading } = props;
  return (
    <ProTable
      columns={orderTableColumns}
      actionRef={orderTableRef}
      request={async (params) => {
        const { data, page, code } = await contentPlayRecordPageList({
          requestData: {
            ...params,
            userId: userId,
          },
          page: {
            currentPage: params.current,
            pageSize: params.pageSize,
          },
        });
        if (code !== '00000') {
          return {
            success: false,
          };
        }
        return {
          data: data,
          success: true,
          total: page.count,
        };
      }}
      columnsState={{
        persistenceKey: 'pro-table-singe-demos2',
        persistenceType: 'localStorage',
      }}
      rowKey={() => guuid()}
      search={false}
      scroll={{ x: 'max-content' }}
      pagination={{
        defaultPageSize: 10,
      }}
      dateFormatter="string"
      toolBarRender={false}
    />
  );
};

export default OrderRecordView;
